import { render } from "./AdminMailTemplatesView.vue?vue&type=template&id=98b46890&scoped=true&ts=true"
import script from "./AdminMailTemplatesView.vue?vue&type=script&lang=ts"
export * from "./AdminMailTemplatesView.vue?vue&type=script&lang=ts"

import "./AdminMailTemplatesView.vue?vue&type=style&index=0&id=98b46890&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98b46890"]])

export default __exports__